//
// Signup.js
// - ------------------------------------------------------
// - Functions to support the Healify Wellness sign up system
// - ------------------------------------------------------
var Airtable = require('airtable');
var base = new Airtable({apiKey: 'keyCv10aSA2Vxn4Ch'}).base('appKMHuPgfJLToeN1');

var username = {}; // new username object
var flower = {}; // new flower object

// imports for image paths
import * as imageURL from "../img/illustrations/flowers/*.svg";
import{ init } from 'emailjs-com';

init("user_yAAcBaQoieqO8Y6shfKeL");

// getUrlVars
// Get variables from a Url formatted like https://page.html?var1=foo&var2=bar
function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
  });
  return vars;
}

// getRandomIntInclusive
// Returns a random integer between the specified values.
// The value is no lower than min (or the next integer greater than min if min isn't an integer), and no greater than max.
function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
}

function updateUseCaseText(){
  const data = getUrlVars();
  var referrer_text = "get started";
  if (data.referrer == 'challenge') {
    referrer_text = "join the challenge";
  }
  $('#referrer_text').text(referrer_text);
}

// generateNewUsername : generate a new username using a new prefix and root
function generateNewUsername(){
  const prefixes = ["zesty", "wise", "spirit", "serene", "rising", "nimble", "love", "life", "joy", "hope", "happy", "golden", "excited", "calm", "brave", "bold", "active", "able"];
  const roots = ["warrior", "maven", "guru", "master", "hero", "ninja", "monkey", "dragon", "sprite", "rabbit", "tiger", "panda", "lion", "genius", "sun", "moon", "beam", "comet", "star", "petal", "lotus", "bud", "sprout", "rose", "holly", "flower"];
  // choose a new prefix index
  if (username.prefix_index === undefined) { // if we haven't run this yet, choose a random value
    username.prefix_index = Math.floor(Math.random() * prefixes.length);
  } else { // otherwise decrement the value, to make sure we keep choosing new prefixes
    username.prefix_index = (username.prefix_index != 0) ? username.prefix_index - 1 : prefixes.length - 1; // decrement it or put it to the end
  }
  // choose a new root index
  if (username.root_index === undefined) { // if we haven't run this yet, choose a random value
    username.root_index = Math.floor(Math.random() * roots.length);
  } else { // otherwise decrement the value, to make sure we keep choosing new roots
    username.root_index = (username.root_index != 0) ? username.root_index - 1 : roots.length - 1; // decrement it or put it to the end
  }
  const my_prefix = prefixes[username.prefix_index][0].toUpperCase() + prefixes[username.prefix_index].substring(1); // capitalize the first letter
  const my_root = roots[username.root_index][0].toUpperCase() + roots[username.root_index].substring(1); // capitalize the first letter
  const random_int = getRandomIntInclusive(11,99); // pick a random number from 11 to 99
  username.name = my_prefix + my_root + random_int;
  $('#signin_error').hide();

  return username;
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

// pickAFlower : pick a flower either at random or based on user selection
function pickAFlower (browse){
  // sorted by alpha (more random feeling)
  // const flowers = ["acanthaceae", "adenium", "brassicarceae", "bromeliaceae", "cespasuchil", "cinquefoil", "daffodil", "dahlia", "daisy", "dapplerose", "flax", "gardenia", "gerbera", "gesneriad", "hibiscus", "holly", "jasmine", "jonquil", "lightsunflower", "lilacrose", "lotus", "myosotis", "narcissus", "oleander", "orchid", "pansy", "parsley", "peaflower", "pear", "pinkcherry", "pinkcosmos", pinkrose", "pointsettia", "poppy", "protea", "redcherry", "redrose", "rose", "sakura", "spiralmela", "spurge", "sunflower", "violet", "wallflower", "zinnia"];
  // sorted by color (more orderly feeling)
  const flowers = ["gardenia", "jonquil", "jasmine", "narcissus", "daisy", "parsley", "pear", "pointsettia", "pinkcosmos", "pinkcherry", "oleander", "sakura", "lotus", "lilacrose", "zinnia", "gerbera", "dahlia", "pansy", "orchid", "spiralmela", "peaflower", "violet", "flax", "myosotis", "spurge", "bromeliaceae", "holly", "protea", "daffodil", "brassicarceae", "lightsunflower", "sunflower", "hibiscus", "cinquefoil", "wallflower", "cespasuchil", "dapplerose", "pinkrose", "redrose", "gesneriad", "acanthaceae", "rose", "poppy", "adenium",  "redcherry"];
  // choose a new flower index
  if (browse == 'random') { // if we haven't run this yet, choose a random value
    flower.flower_index = Math.floor(Math.random() * flowers.length);
  } else if (browse == 'previous') { // if choosing a previous flower
    flower.flower_index = (flower.flower_index != 0) ? flower.flower_index - 1 : flowers.length - 1; // decrement flower index or put it to the end
  } else {
    flower.flower_index = (flower.flower_index != flowers.length - 1) ? flower.flower_index + 1 : 0; // increment flower index or put it to the beginning
  }
  flower.name = flowers[flower.flower_index];
  $('#my_flower').attr("src", imageURL[flower.name]);
  return flower.name;
}
let selectedFlowerName = "";

let selectedUserName = "";
function setName(){
   //some code
  if($("#username_input").val().length) {
    base('users').select({
        view: 'Grid view'
    }).firstPage(function(err, records) {
      let flag = false;
      if (err) {
        console.error(err);
        $('#signin_error').show();
        return; }
        console.log("Heyya", records);
      records.forEach(function(record) {
        if (record.fields["Name"].toLowerCase() === $("#username_input").val().toLowerCase()){
          flag=true;
          alert("Your username is already taken.");
        }
      });
      console.log("flag", flag);
      if (!flag){
        $('#signin_error').hide();
        localStorage.setItem('userName', $("#username_input").val());
        window.location.replace("/signup2.html");

      }
      
    });

  } else {
    $('#signin_error').show();
  }
}

function setFlowerName(){
   //some code
  localStorage.setItem('selectedFlowerName', selectedFlowerName);
}


function checkTOS(){
  if (!$('input.checkbox_check').is(':checked')) {
  }
}

function setEmailDisplay(){
  $("#emailPlaceholder").text(localStorage.getItem('userEmail'));
}
$(document).ready(function(){
  updateUseCaseText();
  $('#create_username').click(function(){
    username = generateNewUsername();

  });
  $("#passUser").removeAttr("href");
  $("#setName").removeAttr("href");
  $('#setName').click(setName);
  $('#passUser').click(()=>{
    if ($("#flexCheckDefault").is(':checked')){
      window.location.replace("/signup4.html");
      $("#tos_error").hide();
    } else {
      $("#tos_error").show();
    }
  });

  $("#emailMe").click(function(){
    if (localStorage.getItem('userName') && localStorage.getItem('selectedFlowerName')){
      if ($('#email_input').val().length && validateEmail($('#email_input').val())){
        localStorage.setItem('userEmail', $('#email_input').val());
        $("#email_error_message").hide();
        base('users').create([
          {
            "fields": {
              "Name": localStorage.getItem('userName'),
              "Email": $('#email_input').val(),
              "flower": localStorage.getItem('selectedFlowerName')
            }
          },
        ], function(err, records) {
          if (err) {
            console.error(err);
            return;
          }
          records.forEach(function (record) {
            // code fragment
            var data = {
                service_id: 'service_healify_sendgrid',
                template_id: 'template_owb4ap2',
                user_id: 'user_yAAcBaQoieqO8Y6shfKeL',
                template_params: {
                    'uuid': record.fields.uuid,
                    'recipient_email': record.fields['Email']
                }
            };
             
            $.ajax('https://api.emailjs.com/api/v1.0/email/send', {
                type: 'POST',
                data: JSON.stringify(data),
                contentType: 'application/json'
            }).done(function() {
                window.location = '/signup5.html';
            }).fail(function(error) {
                alert('Oops... ' + JSON.stringify(error));
            });


          });

          });
      } else {
        $("#email_error_message").show();
      }
    } else {
      alert("Sorry, something went wrong. Please try it again.")
    }



  })
  setEmailDisplay();
  $('#choose_flower').click(function(){
    chooseRandomFlower();
  });
  // functions for signup step 1
  if ($('#signup_step1').length) {
    updateUseCaseText();
    $('#create_username').click(function(){
      username = generateNewUsername();
      $('#username_input').val(username.name);
      selectedUserName = username.name;



    });
  }
  // functions for signup step 2
  if ($('#signup_step2').length) {
    selectedFlowerName = pickAFlower('random');
    $('#browse_previous').click(function(){
      selectedFlowerName = pickAFlower('previous');
    });
    $('#browse_next').click(function(){
      selectedFlowerName = pickAFlower('next');
    });
    $('#setFlower').click(setFlowerName);
  }
  // functions for signup step 3
  if ($('#signup_step3').length) {
    $('#flexCheckDefault').change(function(){
      if(this.checked) { // clear out any displayed error messages if user checks the box
        ($('#form_error')).hide();
        $("#tos_error").hide();

      }
    });
    $('#signup_btn').click(function(e){
      if (!$('#agree_checkbox').prop("checked")) {
        ($('#form_error')).fadeIn();
        e.preventDefault(); // prevent button from working
      }
    });
  }
  // functions for signup step 5
  if ($('#signup_step5').length) {
    $('#close_window').click(function(){
      window.close();
    });
  }
});
